import { byCountryCode } from './countries';

export const getLocationLanguage = language => {
  if (!language) return null;
  const [, countryCode] = language.split('-');
  return countryCode ? countryCode.toUpperCase() : null;
};

export const getBrowserDialCode = () => {
  const country = getLocationLanguage(
    typeof navigator !== 'undefined' ? navigator.language : null,
  );
  return (byCountryCode[country] && byCountryCode[country].dialCode) || '+55';
};
